import { jsonHeaders } from '#lib/helpers/fetch.js';
import { useAuthQuery } from '#lib/hooks/use-query.js';

async function fetchData(_, authHeaders) {
    const response = await fetch(`${API_URL}/p/admin`, {
        headers: { ...jsonHeaders, ...authHeaders }
    });

    return await response.json();
}

export default function useAdmin() {
    const { data, isLoading } = useAuthQuery({
        queryKey: ['admin'],
        queryFn: fetchData
    });

    return {
        data: Object.values(data?.results ? data.results : {}),
        isLoading
    };
}
